import React, { useState, useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import { TABLE_ROWS_PER_PAGE } from "../../utils/Constants";
import SkeletonTicketList from "../../loaders/SkeletonTicketList";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import "jspdf-autotable";
import PermissionsGate from "../../utils/permissionGate";
import hasPermission from "../../utils/hasMultiplePermission";
import Tablefilter from "../common/Tablefilter";
import { RenderMenuStatus, RenderQuizTopic, RenderstatusList } from "../../utils/CommonStatusItems";
import axios from "axios";
import { handleTableScroll } from "../../utils/commonFunction";
import $ from "jquery";
import { DeleteMenuList, GetMenuList, GetMenusListsFilterCancelToken, GetMenuListCancelToken } from "../../services/Menusserver";
import { RenderMenuType } from "../../utils/CommonGroupingItem";
import { popupConfirmDeleteWarning } from "../../utils/Popups";
import { usePermissionGuardRedirect } from "../../hooks/usePermissionGuard";

function LayoutMenus() {
    const [search, setSearch] = useState("");
    const [debouncedTerm, setDebouncedTerm] = useState("");
    const [status, setStatus] = useState({ arr: [], checkObj: {} });
    const [menuType, setMenuType] = useState({ arr: [], checkObj: {} });
    const [assignedSites, setAssignedSites] = useState({ arr: [], checkObj: {} });
    const [searchStatusCheck, setSearchStatusCheck] = useState({});
    const givenPermsisions = useSelector((state) => state.givenPermission);
    const [menuData, setMenuData] = useState([]);
    const [loading, setloading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [updateData, setUpdateData] = useState(true);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [sortkey, setSortKey] = useState("MenuName");
    const [sortOrder, setSortOrder] = useState("ASC");
    const [filterData, setFilterData] = useState({ status: [], menuType: [], assignedSites: [] });


    useEffect(() => {
        handleTableScroll()
    }, [loading])

    useEffect(() => {
        $(document).ready(function () {
            $(".dropdown-toggle").click(function () {
                $('.rdt_TableCell').css('z-index', 0)
                $(this).parents('.rdt_TableCell').css('z-index', 22)
            });
        });
    })

    useEffect(() => {
        const storedFilters = JSON.parse(localStorage.getItem("filterStateMenuListMain"));
        if (storedFilters) {
            setStatus(storedFilters.status);
            setMenuType(storedFilters.menuType);
            setAssignedSites(storedFilters.assignedSites);
        }
    }, []);

    useEffect(() => {
        const filterState = {
            status,
            menuType,
            assignedSites
        };
        localStorage.setItem("filterStateMenuListMain", JSON.stringify(filterState));
    }, [status, menuType, assignedSites]);

    useEffect(() => {
        $(document).ready(function () {
            $(".dropdown-toggle").click(function () {
                $('.rdt_TableCell').css('z-index', 0)
                $(this).parents('.rdt_TableCell').css('z-index', 22)
            });
        });
    })

    // get list
    useEffect(() => {
        const cancelTokenSources = [];

        const getMenuList = async () => {
            setloading(true);

            cancelTokenSources.forEach(source => {
                source.cancel('New request made');
            });

            const source = axios.CancelToken.source();
            cancelTokenSources.push(source);

            const menuData = {
                key: sortkey,
                sort: sortOrder,
                page: page,
                perPage: perPage,
                search: search,
                viaStatus: status?.arr,
                viaType: menuType?.arr,
                viaBrand: assignedSites?.arr
            };

            try {
                const res = await GetMenuListCancelToken(menuData, source.token);
                setMenuData(res?.data?.data);
                setTotalRows(res.data?.total);
                setPerPage(res.data?.perPage);
                if (res.status == 200) {
                    setloading(false);
                }
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error(error);
                    setloading(false);
                }
            }
        }

        getMenuList();

        return () => {
            cancelTokenSources.forEach(source => {
                source.cancel('Component unmounted');
            });
        };
    }, [page, perPage, sortOrder, sortkey, search, status, menuType, assignedSites, searchStatusCheck, updateData]);

    // get dropdownlist
    useEffect(() => {
        const dropdownSource = axios.CancelToken.source();

        const fetchData = async () => {
            try {
                const res = await GetMenusListsFilterCancelToken(dropdownSource.token);
                setFilterData({
                    status: res?.data?.menusStatusFilters,
                    menuType: res?.data?.menusTypesFilters,
                    assignedSites: res?.data?.sitesFilters,
                })
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error(error);
                }
            }
        };

        fetchData();

        return () => {
            dropdownSource.cancel('Component unmounted');
        };
    }, []);

    usePermissionGuardRedirect(['wbslnmenusview']);

    const handleSearchFilter = (e) => {
        const value = e.target.value;
        setDebouncedTerm(value);
    };

    const resetFilter = () => {
        setStatus({ arr: [], checkObj: {} });
        setMenuType({ arr: [], checkObj: {} });
        setAssignedSites({ arr: [], checkObj: {} });
        setSearchStatusCheck({});
        setSearch("");
        setDebouncedTerm("");
    };

    useEffect(() => {
        return resetFilter()
    }, [])

    const handlePageChange = (pageNo) => {
        setPage(pageNo);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
    };

    const handleSort = (column, sortDirection) => {
        setSortKey(column.sortField);
        setSortOrder(sortDirection === "asc" ? "ASC" : "DESC");
    };

    const handleRedirection = (ID) => {
        if (hasPermission({ scopes: ["sgiview"], permissions: givenPermsisions })) {
            return `/studentAdministration/students/open/${ID}/general`;
        } else if (
            hasPermission({ scopes: ["spiview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/personal`;
        } else if (
            hasPermission({ scopes: ["sedview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/education`;
        } else if (
            hasPermission({ scopes: ["sapiview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/account`;
        } else if (
            hasPermission({ scopes: ["scpview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/coursesAndProgramme`;
        } else if (
            hasPermission({ scopes: ["sasview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/assessments`;
        } else if (
            hasPermission({ scopes: ["snview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/notifications`;
        } else if (
            hasPermission({ scopes: ["scaview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/classAttendance`;
        } else if (
            hasPermission({ scopes: ["slview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/licenses`;
        } else if (
            hasPermission({ scopes: ["scview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/certificates`;
        } else if (
            hasPermission({ scopes: ["saview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/appeals`;
        } else if (
            hasPermission({ scopes: ["stview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/tickets`;
        } else if (
            hasPermission({ scopes: ["snoview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/notes`;
        } else {
            return `/studentAdministration/students/open/${ID}/auditTrail/employee`;
        }
    };
    
    const handleDelete = (id) => {
        popupConfirmDeleteWarning((result) => {
            if (result.isConfirmed) {
                DeleteMenuList({ MenuID: id })
                    .then((res) => {
                        Swal.fire("Deleted!", "Menu has been deleted.", "success");
                        setUpdateData(!updateData);
                    })
                    .catch((error) => console.log(error));
            }
        });
    }

    const columns = useMemo(() => [
        {
            name: "Name",
            selector: "MenuName",
            sortField: "MenuName",
            sortable: true,
            cell: (row) => (
                <div>
                    <PermissionsGate scopes={["wbslnmenusedit"]} RenderError={() => <p>{row?.MenuName}</p>}>
                        <Link
                            className="as-text-blue curser feature-name"
                            to={`/websiteManagement/layout_navigation/menus/menu_setting/open/${row.MenuID}`}
                            title={row.MenuName}
                        >
                            <span className="textLimit100">{row.MenuName}</span>
                        </Link>
                    </PermissionsGate>
                </div>
            ),
        },
        {
            name: "Menu Type",
            selector: "menu_type_name",
            sortField: "menu_type_name",
            sortable: true,
            cell: (row) => (
                <>
                    {row.menu_type_name ? (
                        <span>
                            {RenderMenuType(row.menu_type_name).html}
                        </span>
                    ) : (
                        "-"
                    )}
                </>
            ),
        },
        {
            name: "Assigned Brand Templates",
            selector: "brandTemplete",
            sortField: "brandTemplete",
            cell: (row) =>
                row?.brandTemplete && row?.brandTemplete.length ? (
                    <div className="d-flex flex-wrap">
                        {row?.brandTemplete.map((item, index) => (
                            <span key={index} className="mr-1">
                                {/* Assuming RenderQuizTopic returns an object with html property */}
                                {RenderQuizTopic(item.brand_name).html}
                            </span>
                        ))}
                    </div>
                ) : (
                    "-"
                ),
        },
        {
            name: "Menu Items",
            selector: "active_menu_items_count",
            sortField: "active_menu_items_count",
            sortable: true,
            cell: (row) => (
                <div className="assigned-title-block-new">
                    <div className="assigned-title-itm">
                        <Link
                            className="as-text-blue curser feature-name"
                            // to={row.siteDomain}
                            title={row.active_menu_items_count}
                        >
                            <span className="textLimit100">{row.active_menu_items_count}</span>
                        </Link>
                    </div>
                </div>
            ),
        },
        {
            name: "Status",
            selector: "MenuStatus",
            sortField: "MenuStatus",
            sortable: true,
            // maxWidth: "120px",
            // minWidth: "120px",
            cell: (row) => (row.MenuStatus ? RenderstatusList(row.MenuStatus).html : "-"),
        },
        {
            name: "Actions",
            selector: "",
            // maxWidth: "50px",
            cell: (row) => (
                <div className="assessment-08 btn-dropdown-grp">
                    <div className="as-buttons d-flex">
                        <PermissionsGate scopes={['wbslnmenusedit']} RenderError={() => (
                            <button className="btn btn-primary rounded-circle" disabled>
                                <i className="fal fa-folder-open"></i>
                            </button>
                        )}>

                            <Link
                                className="btn btn-primary h-auto rounded-circle"
                                to={`/websiteManagement/layout_navigation/menus/menu_setting/open/${row.MenuID}`}
                                title="Open"
                            >
                                <i className="fal fa-folder-open"></i>
                            </Link>
                        </PermissionsGate>
                        <PermissionsGate scopes={['wbslnmenusdelete']} RenderError={() => (
                            <button className="btn btn-danger rounded-circle" disabled>
                                <i className="fal fa-trash-alt"></i>
                            </button>
                        )}>
                            <button
                                className="btn btn-danger rounded-circle"
                                onClick={() => handleDelete(row.MenuID)}
                                title="Delete"
                            >
                                <i className="fal fa-trash-alt"></i>
                            </button>
                        </PermissionsGate>
                    </div>
                </div>
            ),
        },
    ]);

    // TODO Excel
    // TODO Csv
    // TODO Pdf

    const exportData = (fileType, fileName) => {
        let data = [];
        const header = ["Name", "Menu Type", "Assigned Brand Templates", "Menu Items", "Status"];
        Swal.fire({
            title: "File downloading",
            onOpen: function () {
                Swal.showLoading();
            },
        });

        const menuData = {
            key: sortkey,
            sort: sortOrder,
            page: page,
            perPage: perPage,
            search: search,
            viaStatus: status?.arr,
            viaType: menuType?.arr,
            viaBrand: assignedSites?.arr,
            exportStatus:"true"
        };

        GetMenuList(menuData)
            .then((res) => {
                // console.log(res?.data);
                data = res?.data;

                data = data?.map((row) => {

                    const brandTemplate = row?.brandTemplete?.map((item) => item.brand_name).join(",");

                    return ({
                        ...row,
                        Name: row?.MenuName,
                        "Menu Type": row.menu_type_name ? row.menu_type_name : "-",
                        "Assigned Brand Templates": row.brandTemplete ? brandTemplate : "-",
                        "Menu Items": row.active_menu_items_count,
                        Status: row?.MenuStatus ? RenderstatusList(row?.MenuStatus).text : "-",
                        
                    })
                });

                if (fileType === "csv") {
                    const csvString = Papa.unparse({ fields: header, data });
                    const blob = new Blob([csvString], {
                        type: "text/csv;charset=utf-8,",
                    });

                    const blobURL = window.URL.createObjectURL(blob);

                    // Create new tag for download file
                    const anchor = document.createElement("a");
                    anchor.download = fileName;
                    anchor.href = blobURL;
                    anchor.dataset.downloadurl = [
                        "text/csv",
                        anchor.download,
                        anchor.href,
                    ].join(":");
                    anchor.click();

                    // Remove URL.createObjectURL. The browser should not save the reference to the file.
                    setTimeout(() => {
                        // For Firefox it is necessary to delay revoking the ObjectURL
                        URL.revokeObjectURL(blobURL);
                    }, 1000);
                    Swal.close();
                } else if (fileType === "xlsx") {
                    const compatibleData = data.map((row) => {
                        const obj = {};
                        header.map((col, index) => {
                            obj[col] = row[col];
                        });
                        return obj;
                    });

                    let wb = XLSX.utils.book_new();
                    let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
                        header,
                    });
                    XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
                    XLSX.writeFile(wb, `${fileName}.xlsx`);
                    Swal.close();
                    // Returning false as downloading of file is already taken care of
                    return false;
                }
                if (fileType === "pdf") {
                    const compatibleData = data?.map((row) => {

                        const brandTemplate = row.brandTemplete?.map((item) => item.brand_name).join(",");

                        return [
                            row.MenuName,
                            row.menu_type_name,
                            brandTemplate ? brandTemplate : "-",
                            row.active_menu_items_count,
                            row.MenuStatus,
                        ];
                    });
                    const doc = new JsPDF();
                    doc.autoTable({
                        head: [header],
                        body: compatibleData,
                        styles: {
                            minCellHeight: 10,
                            minCellWidth: 5,
                            halign: "left",
                            fontSize: 8,
                        },
                    });
                    doc.save(`${fileName}.pdf`);
                    Swal.close();
                    return false;
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        const timer = setTimeout(() => setSearch(debouncedTerm), 1000);
        return () => {
            clearTimeout(timer);
        }
    }, [debouncedTerm])

    return (
        <div className="my-tickets-info-list Tickets-main-wrap">
            <div className="custom-table-div filter-search-icon card card-table-custom program-table">
                <div className="search-filter-div">
                    <div className="search-filter-div-left">
                        <div className="system-administration-table table-responsive">
                            <div className="table-responsive-div">
                                <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                                    <div id="assessment-table-main_filter" className="dataTables_filter">
                                        <label>
                                            <input
                                                type="search"
                                                className=""
                                                placeholder="Search"
                                                aria-controls="assessment-table-main"
                                                onChange={handleSearchFilter}
                                                value={debouncedTerm}
                                            />
                                        </label>
                                        <div className="filter-eff filter-data-btn">
                                            <button className="filter-buttons">
                                                <i className="fal fa-filter"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="filter-button-group">
                                <div className="filter-scroll">
                                    <div className={`filter-scroll-inner filter-custom-new`}>
                                        <Tablefilter
                                            filterName="Menu Type"
                                            optionArr={filterData?.menuType}
                                            state={menuType}
                                            setState={setMenuType}
                                            stopOptionSorting={true}
                                            isOptionReversed={false}
                                            renderLabelFunction={RenderMenuType}
                                        />
                                    </div>
                                </div>

                                <div className="filter-scroll">
                                    <div className={`filter-scroll-inner filter-custom-new`}>
                                        <Tablefilter
                                            filterName="Assigned Brand Templates"
                                            optionArr={filterData?.assignedSites}
                                            state={assignedSites}
                                            setState={setAssignedSites}
                                            stopOptionSorting={true}
                                            isOptionReversed={false}
                                        // renderLabelFunction={RenderBranchList}
                                        />
                                    </div>
                                </div>
                                <div className="filter-scroll">
                                    <div className={`filter-scroll-inner filter-custom-new`}>
                                        <Tablefilter
                                            filterName="Status"
                                            optionArr={filterData?.status}
                                            state={status}
                                            setState={setStatus}
                                            stopOptionSorting={true}
                                            isOptionReversed={false}
                                            renderLabelFunction={RenderMenuStatus}
                                        />
                                    </div>
                                </div>
                                <div className="reset-btn-group">
                                    <div className="button-reset dropdown-comman">
                                        <button
                                            className="btn btn-primary"
                                            onClick={resetFilter}
                                            title="Reset"
                                        >
                                            <i className="fal fa-redo"></i>Reset
                                        </button>
                                    </div>
                                    <div className="files-export-group">
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("xlsx", "Menu list");
                                            }}
                                            title="Export spreadsheet"
                                        >
                                            <i className="fal fa-file-excel icon"></i>
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("csv", "Menu list");
                                            }}
                                            title="Export CSV"
                                        >
                                            <i className="fal fa-file-csv icon"></i>
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("pdf", "Menu list");
                                            }}
                                            title="Export PDF"
                                        >
                                            <i className="fal fa-file-pdf icon"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="search-filter-div-right">
                        <div className=" filter-search-bar-blk">
                            <div className="add-ticket-blk button-reset dropdown-comman">
                                <PermissionsGate
                                    RenderError={() => (
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            title="Create new"
                                            disabled
                                        >
                                            <i className="fal fa-plus"></i>Create New
                                        </button>
                                    )}
                                    scopes={["wbslnmenusadd"]}
                                >
                                    <Link to={`/websiteManagement/layout_navigation/menus/menu_setting/create`}>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            title="Create new"
                                        >
                                            <i className="fal fa-plus"></i>Create New
                                        </button>
                                    </Link>
                                </PermissionsGate>
                            </div>
                        </div>
                    </div>
                </div>
                <DataTable
                    paginationDefaultPage={page}
                    progressPending={loading}
                    data={menuData}
                    progressComponent={<SkeletonTicketList />}
                    defaultSortField={sortkey}
                    defaultSortAsc={true}
                    columns={columns}
                    pagination={true}
                    onSort={handleSort}
                    sortServer
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    highlightOnHover={false}
                    paginationPerPage={perPage}
                    paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
                />
            </div>
        </div>
    );
}

export default LayoutMenus;
